import { UrlParamHelper } from '~domain/helper/url/url-param-helper';
import { ApplicationAuthentication } from '~domain/model/account/application-authentication';
import { MagicLinkParamKeys } from '~domain/model/url/url-parameters';

export class MagicLinkAuthExtractor {
  private urlParamHelper = new UrlParamHelper();
  // Parse query string and return Authentication
  public extractAuthFromURLQuery(urlQuery: string): ApplicationAuthentication {
    // Support 'q' as parameters until December 1st 2021.
    // After this date, all url with these parameters won't
    // be valid anymore. From now, use 'a'  as parameters
    const SUPPORTED_APPLICATION_ID2: string = 'q';

    const results: Map<string, string> = this.urlParamHelper.extractParams(urlQuery, [
      MagicLinkParamKeys.token,
      MagicLinkParamKeys.applicationId,
      SUPPORTED_APPLICATION_ID2,
    ]);

    const token = results.get(MagicLinkParamKeys.token);
    const applicationId = results.get(MagicLinkParamKeys.applicationId) || results.get(SUPPORTED_APPLICATION_ID2);

    // BaseUsers don't have an ID in authentication.
    if (!token || token === '' || !applicationId || applicationId === '') return;
    return {
      accessToken: token,
      applicationId: applicationId,
    };
  }
}
